module.exports = __webpack_public_path__ + "static/media/service-center.794ef31b.jpg";